import React from 'react'
import { MapMobileErrorState } from '../../components/mobile'
import ReportMapCanvas from './ReportMapCanvas'
import { TIMESTAMP_MAP_MOBILE_ERROR_MESSAGES } from './helpers/mobileMapErrorCopy'
import { resolveReportGeofence } from './helpers/reportGeofence'

const DEFAULT_CENTER = {
  lat: 8.986984,
  lng: -79.518519
}

const parseCoordinate = (value) => {
  const parsedValue = Number.parseFloat(value)
  return Number.isFinite(parsedValue) ? parsedValue : 0
}

const ShowMapModalTimestampContent = (props) => {
  const isMobileView = Boolean(props.isMobileView)
  const startLatitude = parseCoordinate(props.startLatitude)
  const startLongitude = parseCoordinate(props.startLongitude)
  const endLatitude = parseCoordinate(props.endLatitude)
  const endLongitude = parseCoordinate(props.endLongitude)
  const clientLatitude = parseCoordinate(props.clientLatitude)
  const clientLongitude = parseCoordinate(props.clientLongitude)
  const geofenceInfo =
    props.geofenceInfo ||
    resolveReportGeofence({
      recorded_geo_max_distance_in_meter:
        props.recordedGeoMaxDistanceInMeter ??
        props.salesmanVisitData?.recorded_geo_max_distance_in_meter
    })
  const geofenceRadius = geofenceInfo.radius
  const effectiveLocation = props.salesmanVisitData?.effective_location
  const geofenceStatus = [true, 1].includes(effectiveLocation)
    ? 'inside'
    : [false, 0].includes(effectiveLocation)
      ? 'outside'
      : 'unknown'

  const hasStartCoordinates = startLatitude !== 0 && startLongitude !== 0
  const hasEndCoordinates = endLatitude !== 0 && endLongitude !== 0
  const hasClientCoordinates = clientLatitude !== 0 && clientLongitude !== 0

  const startCenter = {
    lat: startLatitude || DEFAULT_CENTER.lat,
    lng: startLongitude || DEFAULT_CENTER.lng
  }

  const renderErrorState = (messages) => {
    const normalizedMessages = Array.isArray(messages)
      ? messages.filter(Boolean)
      : [messages].filter(Boolean)

    if (!isMobileView) {
      return (
        <div className="map-modal-error">
          {normalizedMessages.map((message, index) => (
            <div key={`timestamp-map-error-${index}`} className="map-error-label">
              {message}
            </div>
          ))}
        </div>
      )
    }

    return <MapMobileErrorState messages={normalizedMessages} />
  }

  if (!hasStartCoordinates) {
    return renderErrorState(
      isMobileView
        ? TIMESTAMP_MAP_MOBILE_ERROR_MESSAGES
        : [
            'La geocoordenada no ha sido capturada. El usuario ha denegado el acceso a la ubicación del equipo. Debe solicitar al usuario que habilite el acceso.'
          ]
    )
  }

  return (
    <ReportMapCanvas
      modern={props.modern}
      captureKind="timestamp"
      geofenceInfo={geofenceInfo}
      geofenceStatus={geofenceStatus}
      isMobileView={isMobileView}
      defaultCenter={startCenter}
      defaultZoom={18}
      maxZoom={props.modern ? 21 : 18}
      singlePointZoom={isMobileView ? 15 : 18}
      fitBoundsPadding={props.modern ? (isMobileView ? 24 : 84) : isMobileView ? 56 : null}
      bindResize
      geofence={
        hasClientCoordinates
          ? { lat: clientLatitude, lng: clientLongitude, radius: geofenceRadius }
          : null
      }
      markers={[
        {
          lat: startLatitude,
          lng: startLongitude,
          name: `Hora de inicio - ${props.salesmanVisitData?.start_visit_time || '-'}`,
          isReport: false,
          color: 'blue',
          controlLabel: 'Inicio',
          controlColor: '#1A73E8'
        },
        ...(hasClientCoordinates
          ? [
              {
                lat: clientLatitude,
                lng: clientLongitude,
                name: 'Ubicación del cliente',
                isReport: true,
                color: 'green'
              }
            ]
          : []),
        ...(hasEndCoordinates
          ? [
              {
                lat: endLatitude,
                lng: endLongitude,
                name: `Hora de finalizacion - ${props.salesmanVisitData?.end_visit_time || '-'}`,
                isReport: false,
                color: 'red',
                controlLabel: 'Fin',
                controlColor: '#e45050'
              }
            ]
          : [])
      ]}
    />
  )
}

export default ShowMapModalTimestampContent
